import {
  borderRadius,
  breakpoints,
  DropdownMenu,
  typographyV2,
} from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const IconWrapper = styled.span`
  display: flex;

  svg {
    fill: var(--icon-default);
  }
`;

export const MainLabel = styled.span<{
  $isAlfred?: boolean;
  $isJapanese?: boolean;
}>`
  color: var(--text-default);
  white-space: nowrap;
  ${typographyV2.bodyBase};

  ${({ $isJapanese }) =>
    $isJapanese &&
    css`
      ${typographyV2.bodySm};
    `}

  ${({ $isAlfred, $isJapanese }) =>
    $isAlfred &&
    $isJapanese &&
    css`
      @media ${breakpoints['max-xl']} {
        ${typographyV2.uiXs};
      }
    `}
`;

export const ItemWrapper = styled.div<{
  $isActive: boolean;
}>`
  position: relative;
  width: 100%;
  height: 100%;
  display: inline-block;
`;

export const ButtonItem = styled.button<{
  $isActive?: boolean;
  $pillStyle?: boolean;
  $isAlfred?: boolean;
  $isJapanese?: boolean;
  $width?: number;
  $height?: number;
  $disabled?: boolean;
}>`
  ${typographyV2.bodyXs};
  ${borderRadius.r2};
  position: relative;
  display: flex;
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  height: 32px;
  padding: 0 4px;

  &:hover,
  &:focus-visible {
    ${MainLabel} {
      color: var(--text-primary);
    }
  }

  ${({ $isAlfred, $isJapanese, $width = 102, $height = 36 }) =>
    $isAlfred &&
    css`
      ${typographyV2.uiBase};
      width: ${$isJapanese ? `calc(${$width}px + 20px)` : `${$width}px`};
      height: ${$height}px;
      display: flex;
      align-items: center;
      justify-content: center;
      ${$isJapanese &&
      css`
        @media ${breakpoints.xxl} {
          width: 140px;
        }
      `}
    `}

  ${({ $pillStyle }) =>
    $pillStyle &&
    css`
      border-radius: 100px;
      background-color: var(--surface-active);
      &:hover {
        background-color: var(--surface-hover);
        svg {
          fill: var(--icon-primary);

          path {
            fill: var(--icon-primary);
          }
        }
      }
    `}
  ${({ $isActive }) =>
    $isActive &&
    css`
      ${MainLabel} {
        color: var(--text-primary);
      }

      svg {
        fill: var(--icon-primary);

        path {
          fill: var(--icon-primary);
        }
      }
    `}


  ${({ $disabled }) =>
    $disabled &&
    css`
      cursor: default;
      pointer-events: none;
    `}

  @media ${breakpoints.xlg} {
    padding: 0 8px;
  }
`;

export const ItemLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const NotificationWrapper = styled.span<{
  $right?: number;
  $top: number;
}>`
  position: absolute;
  top: ${({ $top }) => $top}px;
  right: ${({ $right }) => $right}px;
  z-index: var(--z-tooltip);
`;

export const StyledDropdown = styled(DropdownMenu)`
  width: 135px;
  min-width: 135px;
  max-width: 135px;
  margin-right: 12px;
  ${borderRadius.r2};
`;

export const StyledCustomDropdown = styled(DropdownMenu)`
  min-width: unset;
  max-width: unset;
  padding: 0;
  gap: 0;
  ${borderRadius.r2};
`;
